module.exports = __webpack_public_path__ + "img/Weapon_63.25b36d19.png";